export default __webpack_public_path__ + "static/media/Szarliget.da07fb20.png";